import React from 'react'


export const Spinner = () => {
  return(
    <div className="bet-spinner"></div>
  );
}

export const RichSpinner = () => {
  return (
    <div className="rich-spinner">
      <div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/loaders/index.js